import { IContratoPagedResponse } from "models/response/contrato-paged-response";

export interface ContratoDetailsState {
  contratoDetails: IContratoPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setContratoDetails: 'setContratoDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface ContratoDetailsAction {
  type: ActionType;
  payload: any;
}

export const ContratoDetailsReducer = (
  state: ContratoDetailsState,
  action: ContratoDetailsAction
): ContratoDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setContratoDetails:
      return { ...state, contratoDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
